module.exports = __webpack_public_path__ + "img/layer2Blobs-PurpleBlue.b9b69b88.svg";